import { memo } from 'react';

interface IPdf {
  file: string;
}

export const Pdf = memo(({ file }: IPdf) => {
  return (
    <div className='h-screen w-full'>
      <iframe src={file} className='h-full w-full' frameBorder={0} />
    </div>
  );
});

Pdf.displayName = 'Pdf';
